import React, { Component } from 'react';
import Header from './common/containers/Header';
import Navigator from './Navigator';
import Cookie from './common/components/Cookie';
import GoogleAnalyticsProvider from './common/utils/ga';
import { BrowserRouter } from 'react-router-dom';
import { Authenticator } from 'aws-amplify-react';
import CustomAuthenticator from './public/containers/Auth';
import { Auth, Hub } from 'aws-amplify';
import { updateInPath, setUser } from './common/utils';
import { clone } from 'ramda';

import AWSAppSyncClient from "aws-appsync";
import { Rehydrated } from 'aws-appsync-react';
import { AUTH_TYPE } from "aws-appsync/lib/link/auth-link";
import { ApolloProvider } from 'react-apollo';
// import { onError } from "apollo-link-error";


const client = new AWSAppSyncClient({
  url: 'https://mv6t4je3tra23hk5vxgvmixxg4.appsync-api.eu-central-1.amazonaws.com/graphql',
  region: 'eu-central-1',
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => (await Auth.currentSession()).getIdToken().getJwtToken()
  },
  disableOffline: true
});

window.adminClient = client;

const pubClient = new AWSAppSyncClient({
  url: 'https://mn5enrenmjatnlxyea5bpbsmfa.appsync-api.eu-central-1.amazonaws.com/graphql',
  region: 'eu-central-1',
  auth: {
    type: AUTH_TYPE.API_KEY,
    apiKey: 'da2-ionapucq3bbqffjmcpsyf7wjde'
  }
});

window.pubClient = pubClient;

class App extends Component {
  constructor(props) {
    super();

    this.state = {
      user: null
    };
    Hub.listen('auth', this);
  }

  onHubCapsule = ({ channel, payload }) => {
    if (channel === 'auth') {
      if (['signIn', 'signUp'].includes(payload.event)) {
        this.checkUser();
      } else if (payload.event === 'signOut') {
        this.setUser(null);
      }
    }
  };

  checkUser = () => {
    Auth.currentAuthenticatedUser()
      .then(user =>  this.setUser(user))
      .catch(err => this.setUser(null));
  }

  setUser = (user) => {
    this.setState(prevState => updateInPath(prevState, 'user', user));
    setUser(user);
  }

  componentDidMount() {
    this.checkUser();
  }

  // TODO: move App outside of custom auth!
  render() {
    const { user } = this.state;

    let groups = [];
    try {
      groups = clone(user.signInUserSession.accessToken.payload['cognito:groups']) || [];
    } catch (err) {}

    return (
      <BrowserRouter>
        <Authenticator hideDefault>
          <GoogleAnalyticsProvider trackingId='UA-126649545-1'/>
          <Cookie/>
          <Header user={user} groups={groups} />
          <ApolloProvider client={client}>
            <Rehydrated>
              <Navigator user={user} groups={groups} />
            </Rehydrated>
          </ApolloProvider>
          <CustomAuthenticator user={user} />
        </Authenticator>

      </BrowserRouter>
    );
  }
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js